var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"center"}},[_vm._m(0),_c('div',{staticClass:"up"},_vm._l((_vm.titleItem),function(item,index){return _c('div',{key:index,staticClass:"bg-ls item"},[_c('div',{class:'divsj'+index},[_c('p',{class:'name'+index},[_vm._v(_vm._s(item.title))])])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_bg"},[_c('p',[_vm._v("服务业务")])])
}]

export { render, staticRenderFns }